import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from "react-redux";

// Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import FileViewerModalForHB from "../../../Components/FileViewer/FileViewerModalForHB";
import Loader from "../../../Components/Loader";
import WorkflowApproveReject from "../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";

// Redux
import { getSampleRequestDetail } from "../../../redux/feature/supplier_app/sampleSlice";

const ArtworkApproval = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Sampling Process");
  localStorage.setItem("submenu", "Sampling List");

  // Read sampleRequestNr and detail from Redux store
  const sampleRequestNr = useSelector(
    (state) => state?.sample?.sample_request_detail?.sampleRequestNr,
  ) || localStorage.getItem("sample_request_nr");

  const sampleDetailData = useSelector(
    (state) => state?.sample?.sample_request_detail?.data,
  );
  const loading = useSelector(
    (state) => state?.sample?.sample_request_detail?.status || false,
  );

  const workflow = useSelector(
    (state) => state?.sample?.sample_request?.workflowSample,
  );

  const [isCardVisibleReview, setCardVisibleReview] = useState(true);
  const [isCardVisibleDecision, setCardVisibleDecision] = useState(true);

  // File Viewer modal state
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    if (sampleRequestNr) {
      dispatch(getSampleRequestDetail({ sampleRequestNr }));
    }
  }, [dispatch, sampleRequestNr]);

  const designFileId =
    sampleDetailData?.artwork?.files?.designFileAttachmentId ||
    sampleDetailData?.designFileAttachmentId;

  const specSheetId =
    sampleDetailData?.artwork?.files?.specSheetAttachmentId ||
    sampleDetailData?.specSheetAttachmentId;

  const referenceImageId =
    sampleDetailData?.artwork?.files?.referenceImageAttachmentId ||
    sampleDetailData?.referenceImageAttachmentId;

  const guidelinesId =
    sampleDetailData?.artwork?.files?.brandingGuidelinesAttachmentId ||
    sampleDetailData?.brandingGuidelinesAttachmentId;

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Artwork Review & Approval</h2>
            <p className="subText">
              Review Sample Request: <strong>{sampleRequestNr}</strong>
            </p>
            <hr />

            <Loader isLoading={loading} className={"text-center"} />

            {/* Universal Workflow Action Bar (Go Back, Approve, Reject with standard modals) */}
            <Row className="mb-3">
              <Col xs={12} md={12} lg={12}>
                <WorkflowApproveReject workflowData={workflow} />
              </Col>
            </Row>

            {!loading && (
              <>
                {/* SECTION 1: Artwork Review Card */}
                <div className="accordion mb-4" id="reviewAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row
                        className="accordion-button"
                        onClick={() => setCardVisibleReview(!isCardVisibleReview)}
                      >
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              isCardVisibleReview ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AR</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Artwork Review</span>
                          <span className="subHeaderTitle">
                            Visual artwork inspection and specification verification
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisibleReview ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {/* Left Column: Attached Specifications */}
                          <Col xs={12} md={5} lg={4} className="mb-3">
                            <div className="p-3 border rounded bg-light h-100">
                              <h6 className="fw-bold mb-3 text-secondary d-flex align-items-center">
                                <i className="bi bi-paperclip me-2 text-primary"></i>
                                ATTACHED SPECIFICATIONS
                              </h6>

                              {/* 1. Design File */}
                              <div className="p-2 mb-2 rounded bg-white border">
                                <div className="text-muted small text-uppercase" style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px" }}>
                                  Design File (Artwork)
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                  <span style={{ fontSize: "13px", fontWeight: 600 }}>Vector Design File</span>
                                  {designFileId ? (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: "12px", padding: "3px 10px" }}
                                      onClick={() => handleViewFile(designFileId)}
                                    >
                                      <i className="bi bi-eye me-1"></i> View File
                                    </button>
                                  ) : (
                                    <span className="badge bg-light text-muted border" style={{ fontSize: "11px" }}>
                                      Not uploaded
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* 2. Specification Sheet / Tech Pack */}
                              <div className="p-2 mb-2 rounded bg-white border">
                                <div className="text-muted small text-uppercase" style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px" }}>
                                  Specification Sheet / Tech Pack
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                  <span style={{ fontSize: "13px", fontWeight: 600 }}>Tech Pack Document</span>
                                  {specSheetId ? (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: "12px", padding: "3px 10px" }}
                                      onClick={() => handleViewFile(specSheetId)}
                                    >
                                      <i className="bi bi-eye me-1"></i> View File
                                    </button>
                                  ) : (
                                    <span className="badge bg-light text-muted border" style={{ fontSize: "11px" }}>
                                      Not uploaded
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* 3. Reference Image */}
                              <div className="p-2 mb-2 rounded bg-white border">
                                <div className="text-muted small text-uppercase" style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px" }}>
                                  Reference Image
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                  <span style={{ fontSize: "13px", fontWeight: 600 }}>Product Mockup Photo</span>
                                  {referenceImageId ? (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: "12px", padding: "3px 10px" }}
                                      onClick={() => handleViewFile(referenceImageId)}
                                    >
                                      <i className="bi bi-eye me-1"></i> View Image
                                    </button>
                                  ) : (
                                    <span className="badge bg-light text-muted border" style={{ fontSize: "11px" }}>
                                      Not uploaded
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* 4. Branding Guidelines */}
                              <div className="p-2 rounded bg-white border">
                                <div className="text-muted small text-uppercase" style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px" }}>
                                  Branding Guidelines
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                  <span style={{ fontSize: "13px", fontWeight: 600 }}>Guidelines & Logo Standards</span>
                                  {guidelinesId ? (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: "12px", padding: "3px 10px" }}
                                      onClick={() => handleViewFile(guidelinesId)}
                                    >
                                      <i className="bi bi-eye me-1"></i> View PDF
                                    </button>
                                  ) : (
                                    <span className="badge bg-light text-muted border" style={{ fontSize: "11px" }}>
                                      Not uploaded
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Right Column: Specifications Form Grid */}
                          <Col xs={12} md={7} lg={8}>
                            <Row>
                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Item Description"
                                  value={sampleDetailData?.itemDescription || ""}
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Brand"
                                  value={sampleDetailData?.artwork?.brand || sampleDetailData?.brand || ""}
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Colour / Shade"
                                  value={sampleDetailData?.artwork?.colour || sampleDetailData?.colour || ""}
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Sizes Required"
                                  value={
                                    Array.isArray(sampleDetailData?.artwork?.sizes || sampleDetailData?.sizes)
                                      ? (sampleDetailData?.artwork?.sizes || sampleDetailData?.sizes).join(", ")
                                      : sampleDetailData?.artwork?.sizes || sampleDetailData?.sizes || ""
                                  }
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Business Unit"
                                  value={sampleDetailData?.businessUnit || ""}
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding mb-3">
                                <InputField
                                  className="inputBox"
                                  label="Item Category"
                                  value={sampleDetailData?.itemCategory || ""}
                                  disabled={true}
                                />
                              </Col>

                              <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding mb-3">
                                <TextAreaField
                                  className="inputBox"
                                  label="Branding & Logo Instructions"
                                  value={sampleDetailData?.artwork?.additionalInfo || sampleDetailData?.additionalInfo || ""}
                                  disabled={true}
                                  rows={2}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* SECTION 2: Workflow & Document Status */}
                <div className="accordion mb-4" id="decisionAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row
                        className="accordion-button"
                        onClick={() => setCardVisibleDecision(!isCardVisibleDecision)}
                      >
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${
                              isCardVisibleDecision ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">WS</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Workflow & Approval Information</span>
                          <span className="subHeaderTitle">
                            Current approval status, initiator info, and audit history
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisibleDecision ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-3">
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mb-3">
                            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                              Current Status
                            </label>
                            <div className="mt-1 sampling-status-container" style={{ width: "fit-content", minWidth: "180px" }}>
                              <style>{`
                                .sampling-status-container .bg-table-status {
                                  white-space: nowrap !important;
                                  display: inline-block !important;
                                  padding: 4px 14px !important;
                                }
                              `}</style>
                              <TableStatusField status={sampleDetailData?.status || "Under Review"} />
                            </div>
                          </Col>

                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mb-3">
                            <InputField
                              className="inputBox"
                              label="Initiator"
                              value={sampleDetailData?.createdBy || "1ADMIN1"}
                              disabled={true}
                            />
                          </Col>

                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding mb-3">
                            <InputField
                              className="inputBox"
                              label="Submitted Date"
                              value={sampleDetailData?.submittedOn || sampleDetailData?.expectedSampleDate || ""}
                              disabled={true}
                            />
                          </Col>

                          {/* Approval Logs History */}
                          {sampleDetailData?.approvalLogs?.length > 0 && (
                            <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding mt-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion mb-2">
                                Approval History & Remarks
                              </label>
                              <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Action</th>
                                      <th>Action By</th>
                                      <th>Remarks</th>
                                      <th>Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {sampleDetailData.approvalLogs.map((log, idx) => (
                                      <tr key={idx}>
                                        <td>
                                          <span
                                            className={`badge ${
                                              log.action === "Approved"
                                                ? "bg-success"
                                                : log.action === "Rejected"
                                                ? "bg-danger"
                                                : "bg-primary"
                                            }`}
                                          >
                                            {log.action}
                                          </span>
                                        </td>
                                        <td>{log.user || log.actionBy || "-"}</td>
                                        <td>{log.comments || log.remarks || "-"}</td>
                                        <td>
                                          {log.timestamp
                                            ? new Date(log.timestamp).toLocaleString()
                                            : "-"}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {/* File Viewer Modal */}
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default ArtworkApproval;
